export const cols_1= [
    {
      title: "排名",
      key: "ranking",
      width:"10vw",
      align: "center",
      slot: "ranking"
    },
    {
      title: "图片",
      key: "img",
      align: "center",
      slot: "img"
    },
    {
      title: "货号",
      key: "goodsno",
      align: "center"
    },
    {
      title: "支付买家数",
      key: "pay_buyer",
      align: "center"
    },
    {
      title: "支付件数",
      key: "pay_number",
      align: "center"
    },
    {
      title: "支付金额",
      key: "pay_amount",
      align: "center"
    }
  ]

  export const cols_2= [
    {
        title: "排名",
        width:"10vw",
        key: "ranking",
        align: "center",
        slot: "ranking"
      },
      {
        title: "图片",
        key: "img",
        align: "center",
        slot: "img"
      },
      {
        title: "货号",
        key: "goodsno",
        align: "center"
      },
      {
        title: "商品浏览量",
        key: "goods_browse",
        align: "center"
      },
      {
        title: "商品访客数",
        key: "goods_visitor",
        align: "center"
      },
      {
        title: "支付件数",
        key: "pay_number",
        align: "center"
      }
  ]